import { TelephonyEvent } from "@/features/telephony/types/telephony-events.types";

type Listener = (event: TelephonyEvent) => void;

export class TelephonyEventBus {
    private listeners = new Set<Listener>();

    subscribe(listener: Listener): () => void {
        this.listeners.add(listener);
        return () => this.listeners.delete(listener);
    }

    emit(event: TelephonyEvent): void {
        this.listeners.forEach((listener) => listener(event));
    }
}
